import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import { MARKIT_DOCS } from "@markit/common.utils";
import { DMAutomationPlatform } from "@markit/common.types";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../../../Containers/PopupModalContainer";
import { HorizontalDivider } from "../../../Dividers/HorizontalDivider";
import RectangleButton from "../../../Buttons/RectangleButton";
import TextHoverInlineButton from "../../../Buttons/TextHoverInlineButton";
import { Colors } from "../../../../utils/colors";
import { getAccountSlice } from "../../../../redux/slices/accountSlice";
import { getInstagramOAuthURL } from "../../../../utils/instagramApiUtils";
import { SocialPlatformIconItem } from "../../../DisplayItem/AutoDM/SocialPlatformIconItem";

type ConnectInstagramModalProps = {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
};

// Confirmation modal shown before sending the creator to Instagram's OAuth flow -
// used both for connecting a brand-new account and for reconnecting an Errored one.
const ConnectInstagramModal = (props: ConnectInstagramModalProps) => {
  const { showModal, setShowModal } = props;
  const { accountData } = useSelector(getAccountSlice);

  return (
    <PopupModalContainer
      hideModal={!showModal}
      closeModal={() => setShowModal(false)}
      modalContentWidth={PopupModalContainerWidth.SMALL}
      noExit
      noDivider
      closeOnOutsidePress
      valueComp={
        <div className="ColumnNormal" style={{ gap: 14 }}>
          <div className="AlignedRow" style={{ gap: 7 }}>
            <SocialPlatformIconItem
              platform={DMAutomationPlatform.INSTAGRAM}
              size={20}
              noBorder
            />
            <span className="sectionTitle">Connect to Instagram</span>
          </div>
          <div className="ColumnNormal" style={{ gap: 7 }}>
            <span className="bodyRegular">
              We&apos;ll take you to Instagram to connect. Just set your
              permissions, and your Instagram account will be linked to
              Markit.
            </span>
            <span className="smallBodySubtext">
              We recommend disconnecting your Instagram account from other
              automation platforms.{" "}
              <TextHoverInlineButton
                text="Learn more"
                onPress={() =>
                  window.open(MARKIT_DOCS + "/connectinstagram#before-you-start")
                }
                icon={
                  <Icon
                    icon="ion:chevron-forward"
                    height={12}
                    style={{ color: Colors.BLUE5, marginBottom: -2 }}
                  />
                }
                iconPosition="right"
                textStyles={{ color: Colors.BLUE5 }}
              />
            </span>
          </div>
        </div>
      }
      fixedBottomContent={
        <div className="ColumnNormal" style={{ gap: 14, paddingTop: 14 }}>
          <HorizontalDivider />
          <div style={{ paddingInline: 14 }}>
            <RectangleButton
              buttonLabel="Connect"
              onPress={() => {
                window.location.href = getInstagramOAuthURL(accountData.uid);
              }}
              altColor={Colors.BLACK}
              altTextColor={Colors.WHITE}
              altPaddingHorz={24}
              altPaddingVert={14}
              iconRight={
                <Icon
                  icon="mdi:external-link"
                  height={16}
                  style={{ color: Colors.WHITE }}
                />
              }
              containerStyles={{ width: "100%" }}
            />
          </div>
        </div>
      }
    />
  );
};

export default ConnectInstagramModal;
